/* eslint-disable new-cap */
import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";
// import { Fade } from "@mui/material";

export default makeStyles(theme => ({
  logotype: {
    color: "white",
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    fontWeight: 500,
    fontSize: 18,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none"
    },
    "@media (max-width: 600px)": {
      marginLeft: 0
    }
  },
  logo: {
    height: "40px",
    "@media (max-width: 600px)": {
      height: "28px",
      marginTop: "15px"
    }
  },
  appBar: {
    width: "100vw",
    zIndex: theme.zIndex.drawer + 1,
    height: 64,
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    backgroundColor: "white !important"
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    justifyContent: "space-between",
    cursor: "pointer"
  },
  environment: {
    fontSize: 14,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 6,
    fontWeight: "bold",
    marginRight: "auto",
    textTransform: "uppercase",
    background: theme.palette.primary.main,
    [theme.breakpoints.up("xl")]: {
      marginLeft: 100
    },
    [theme.breakpoints.down("xl")]: {
      marginLeft: 100
    },
    [theme.breakpoints.down("lg")]: {
      marginLeft: 100
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: 5
    },
    // [theme.breakpoints.up("sm")]: {
    //   marginLeft: 5
    // },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  sitemapimage: {
    padding: "8px 9px 4px 9px",
    background: "#F0F2F5",
    borderRadius: "50%"
  },
  hide: {
    display: "none"
  },
  grow: {
    flexGrow: 1
  },
  search: {
    position: "relative",
    borderRadius: 25,
    paddingLeft: theme.spacing(2.5),
    width: 36,
    // backgroundColor: Fade(theme.palette.common.black, 0),
    transition: theme.transitions.create(["background-color", "width"]),
    "&:hover": {
      cursor: "pointer"
      // backgroundColor: Fade(theme.palette.common.black, 0.08)
    }
  },
  searchFocused: {
    // backgroundColor: Fade(theme.palette.common.black, 0.08),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 400
    },
    [theme.breakpoints.down("sm")]: {
      width: 250
    }
  },
  searchIcon: {
    width: 36,
    right: 10,
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.ash,
    transition: theme.transitions.create("right"),
    "&:hover": {
      cursor: "pointer"
    }
  },
  searchIconOpened: {
    left: -10
  },
  inputRoot: {
    color: "inherit",
    width: "100%"
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingRight: 36 + theme.spacing(1.25),
    width: "100%",
    backgroundColor: `${theme.palette.color.grey50}!important`,
    borderRadius: 6,
    boxSizing: "border-box",
    paddingLeft: "12px!important"
  },
  messageContent: {
    display: "flex",
    flexDirection: "column"
  },
  demo: {
    border: `1px solid ${theme.palette.primary.main}`,
    padding: "1px 10px",
    borderRadius: 4,
    color: theme.palette.primary.main,
    fontSize: "1.2rem",
    position: "relative"
  },
  demodropdown: {
    position: "absolute",
    background: "white",
    padding: "1rem",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "-2rem",
    marginTop: "1.5rem",
    bottom: -"5rem",
    left: "-15rem",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    [theme.breakpoints.down(700)]: {
      marginLeft: "2rem",
      marginRight: "-4rem",
      left: "-15rem"
    }
  },
  demoleft: {
    paddingRight: "2rem"
  },
  demoNum: {
    margin: 0,
    color: "#0B0B0B",
    whiteSpace: "nowrap",
    fontSize: "20px"
  },
  demoText: {
    margin: 0,
    whiteSpace: "nowrap",
    color: "#6D6D6D",
    fontSize: "12px"
  },
  closeIcon: {
    top: -2,
    marginRight: "-4px",
    marginTop: "-4px",
    right: -2,
    position: "absolute"
  },
  headerMenu: {
    marginTop: theme.spacing(3),
    borderRadius: 12
  },
  headerProfileMenu: {
    marginTop: theme.spacing(3),
    borderRadius: 12,
    minWidth: "280px !important"
  },
  headerMenuList: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "10px",
    paddingRight: "10px"
  },
  headerMenuItem: {
    "-webkit-touch-callout": "none", // iOS Safari
    "-webkit-user-select": "none",   // Safari
    "-khtml-user-select": "none",    // Konqueror HTML
    "-moz-user-select": "none",      // Old versions of Firefox
    "-ms-user-select": "none",       // Internet Explorer/Edge
    "user-select": "none",           // Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox
    "touch-action": "none",          // Disable touch actions like long press
    "context-menu": "none",          // Disable context menu
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
      display: "flex !important",
      alignItems: "center !important",
      gap: "10px !important"
      // color: "white",
    }
  },
  menuText: {
    marginLeft: theme.spacing(2)
  },
  headerMenuButton: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5),
    color: `${theme.palette.primary.main}!important`
  },
  headerMenuButtonSandwich: {
    marginLeft: 9,
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0
    },
    padding: theme.spacing(0.5)
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing(2)
  },
  headerIcon: {
    fontSize: 28,
    color: theme.palette.primary.main
  },
  headerIconCollapse: {
    color: theme.palette.primary.main
  },
  profileMenu: {
    minWidth: 265
  },
  profileMenuUser: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2)
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
    backgroundColor: theme.palette.color.primary
  },
  profileMenuIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.color.grey100
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: "none",
    backgroundColor: theme.palette.color.grey100,
    "&:hover": {
      cursor: "pointer"
    }
  },
  messageNotification: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.grey100,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light
    }
  },
  messageNotificationSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: theme.spacing(2)
  },
  messageNotificationBodySide: {
    alignItems: "flex-start",
    marginRight: 0
  },
  sendMessageButton: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textTransform: "none"
  },
  sendButtonIcon: {
    marginLeft: theme.spacing(2)
  },
  purchaseBtn: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
    marginRight: theme.spacing(3)
  },
  notificationbadge: {
    borderRadius: 12,
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(45).toHexString(),
    color: theme.palette.primary.main,
    fontSize: 12,
    letterSpacing: "-0.1px",
    padding: "3px 8px"
  },
  alertbadge: {
    borderRadius: "50%",
    width: 20,
    height: 20,
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontSize: 12,
    letterSpacing: "-0.1px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: -6,
    right: -4
  },
  notifyitems: {
    width: "300px",
    "-webkit-touch-callout": "none", // iOS Safari
    "-webkit-user-select": "none",   // Safari
    "-khtml-user-select": "none",    // Konqueror HTML
    "-moz-user-select": "none",      // Old versions of Firefox
    "-ms-user-select": "none",       // Internet Explorer/Edge
    "user-select": "none",           // Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox
    "touch-action": "none",          // Disable touch actions like long press
    "context-menu": "none",          // Disable context menu
    "& p": {
      fontWeight: 400,
      fontSize: 12,
      marginBlock: 0
    },
    "& h4": {
      fontWeight: 400,
      fontSize: 14,
      width: "225px",
      overflow: "hidden"
    }
  },
  notificationtime: {
    justifyItems: "center",
    // width: "100%",
    position: "relative",
    "& p": {
      textAlign: "right",
      marginTop: 16
    },
    "& img": {
      position: "absolute",
      right: 0,
      top: 0
    }
  },
  notifyheader: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.primary.main
  },
  notifyBody: {
    fontSize: 12,
    fontWeight: 400,
    padding: "4px 0"
  },
  notifyfooter: {
    "& p": {
      fontSize: 12,
      fontWeight: 700,
      color: theme.palette.primary.main
    }
  },
  flexresponsive: {
    flex: "0 0 75%"
  },
  initials: {
    backgroundColor: "#F0F2F5",
    color: "black",
    fontSize: 22,
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"

  },
  plan: {
    background: tinycolor(theme.palette.primary.main).lighten(40).toHexString(),
    padding: "4px 12px",
    paddingBottom: "5px",
    borderRadius: "8px"
  },
  planText: {
    margin: 0,
    color: "black",
    fontSize: "14px",
    display: "flex",
    flexDirection: "column"
  },
  planSubText: {
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: "11px",
    lineHeight: "12px"
  },
  ward_div: {
    margin: 0,
    color: "#202124",
    fontSize: "14px",
    padding: "16px 16px",
    textAlign: "left",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    borderBottom: "1px solid #f0f0f0",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: tinycolor(theme.palette.primary.main).lighten(40).toHexString()
    },
    "&:last-child": {
      borderBottom: "none"
    },
    [theme.breakpoints.down(450)]: {
      padding: "16px 8px",
      gap: "6px"
    }
  },
  warddropdown: {
    position: "absolute",
    background: "white",
    padding: "1rem",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "1.5rem",
    bottom: -"5rem",
    left: "-10rem",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    [theme.breakpoints.down(700)]: {
      marginLeft: "2rem",
      marginRight: "-4rem",
      left: "-8rem"
    }
  },
  wardInitial: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(40).toHexString(),
    color: "white",
    borderRadius: "50%",
    fontSize: 12,
    fontWeight: "bold",
    marginRight: 8
  },
  accountWrapper: {
    padding: "12px"
  },

  accountItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },

  avatarCircle: {
    width: 36,
    height: 36,
    borderRadius: "50%",
    backgroundColor: "#E5E7EB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    overflow: "hidden"
  },

  avatarImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  accountInfo: {
    flex: 1
  },

  accountName: {
    fontSize: "14px",
    fontWeight: 500,
    margin: 0
  },

  accountRole: {
    fontSize: "12px",
    color: "#6B7280"
  },

  activeDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#16A34A"
  },

  menuDivider: {
    height: 1,
    background: "#E5E7EB",
    margin: "8px 0"
  },
  switchAccountBtn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "8px",
    borderRadius: "10px",
    marginTop: "8px",
    border: "1px solid #D0D5DD",
    background: "#fff",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer"
  },

  // School Selection Modal Styles
  selectionList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "32px",
    marginTop: "15px"
  },

  selectionCard: {
    display: "flex",
    alignItems: "center",
    padding: "12px",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    cursor: "pointer",
    background: "#fff",
    transition: "all 0.2s ease",
    justifyContent: "space-between",
    "&:hover": {
      borderColor: "#4d8df8"
    },
    "&:hover $cardIconWrapper": {
      backgroundColor: "#0d6efd",
      border: "1px solid #0d6efd",
      color: "white"
    },
    "&:hover $cardArrow": {
      color: "#1a1a1a",
      display: "flex",
      alignItems: "center",
      transition: "ease-in-out 0.5s"
    }
  },

  selectionCardActive: {
    borderColor: "#0d6efd",
    backgroundColor: "#f0f7ff",
    "& $cardIconWrapper": {
      backgroundColor: "#0d6efd",
      border: "1px solid #0d6efd",
      color: "white"
    },
    "& $cardArrow": {
      color: "#0d6efd",
      display: "flex",
      alignItems: "center"
    }
  },

  cardIconWrapper: {
    width: "40px",
    height: "40px",
    backgroundColor: "transparent",
    border: "1px solid #96C0FF",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#96C0FF",
    transition: "all 0.2s ease"
  },

  cardInfo: {
    flex: 1
  },

  cardInfoTitle: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#1a1a1a",
    margin: 0
  },

  cardArrow: {
    color: "#1a1a1a",
    display: "none"
  },

  // Role Selection Modal Styles
  roleGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginBottom: "32px",
    marginTop: "18px",
    [theme.breakpoints.down(768)]: {
      gridTemplateColumns: "1fr 1fr",
      padding: "20px"
    },
    [theme.breakpoints.down(550)]: {
      gridTemplateColumns: "1fr",
      padding: 0
    }
  },

  roleCard: {
    background: "#FFFFFF",
    borderRadius: "12px",
    border: "1px solid #e0e0e0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "30px 20px 20px 20px",
    cursor: "pointer",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      borderColor: "#1A73E8",
      backgroundColor: "#FFFFFF"
    },
    "&:hover $roleIconWrapper": {
      color: "#0d6efd !important"
    },
    "&:hover $roleArrow": {
      opacity: 1,
      transform: "translateX(0)",
      color: "#0d6efd"
    },
    [theme.breakpoints.down(768)]: {
      width: "100%",
      maxWidth: "320px",
      height: "180px"
    }
  },

  roleCardSelected: {
    borderColor: "#0d6efd",
    backgroundColor: "#f0f7ff",
    transform: "translateY(-2px)",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    "& $roleIconWrapper": {
      color: "#0d6efd !important"
    },
    "& $roleName": {
      color: "#000000",
      fontWeight: 700
    },
    "& $roleArrow": {
      opacity: 1,
      transform: "translateX(0)",
      color: "#0d6efd"
    }
  },

  roleIconWrapper: {
    height: "fit-content",
    color: "#98A2B3"
  },

  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1
  },

  roleName: {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: "#000000",
    marginTop: 0,
    transition: "color 0.3s ease",
    marginBottom: "8px",
    textTransform: "capitalize"
  },

  roleArrow: {
    height: "24px",
    opacity: 0,
    transform: "translateX(-10px)",
    transition: "all 0.3s ease"
  }

}));
